import { render } from "./MultipleChoice.vue?vue&type=template&id=8087cfe8&scoped=true"
import script from "./MultipleChoice.vue?vue&type=script&lang=js"
export * from "./MultipleChoice.vue?vue&type=script&lang=js"

import "./MultipleChoice.vue?vue&type=style&index=0&id=8087cfe8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8087cfe8"

export default script